import { useQuery } from '@tanstack/react-query'
import { getShipperById } from './client'

export const useShipper = () =>
  useQuery({
    queryKey: ['GET_SHIPPER_BY_ID'],
    queryFn: () => getShipperById(process.env.NEXT_PUBLIC_SHIPPER_ID || ''),
  })
